/**
 * Quality-judge shared service.
 *
 * The judge Lambda lives in the SIT infra (us-east-1) and is fronted by the SIT
 * API Gateway's `POST /quality-judge` route. Both SIT (importer plans) and
 * AgentStudio (agent JSON, flow JSON) call it from the SPA via this client.
 *
 * Reuses the SIT axios instance so we inherit the same Bearer-token MSAL flow
 * (acquireTokenSilent → acquireTokenPopup) and base URL plumbing. Cross-platform
 * coupling is intentional: the judge is owned by SIT but consumed by both
 * platforms, and standing up a separate API base for it just to look
 * platform-agnostic would buy nothing.
 *
 * Body shape (dispatched server-side on `kind`):
 *
 *   sit-plan
 *     { kind: "sit-plan",
 *       source: { kind: "diagram"|"excel"|"kb", description: string },
 *       sourceContent: string,
 *       plans: TestPlan[] }
 *
 *   agentstudio-agent
 *     { kind: "agentstudio-agent",
 *       formInput: { name, description, persona, ... },
 *       agentJson: { ... },
 *       standards: { ... } }
 *
 *   agentstudio-flow
 *     { kind: "agentstudio-flow",
 *       botInventory: [...],
 *       tenantTemplate: { ... },
 *       flowJson: { ... } }
 *
 * Returns: { overallScore: number, perItem: JudgeFinding[], modelId, durationMs }
 */

import { sitApi } from '../../platforms/sit/api_scripts/sitApiClient';

export async function callQualityJudge(body) {
  const { data } = await sitApi.post('/quality-judge', body);
  return data;
}

/**
 * Pick the perItem findings that are worth feeding back into the next
 * generation pass. `info` severity is advisory only — dropping it keeps the
 * regenerate prompt focused on the real problems and saves prompt budget.
 */
export function findingsForRegenerate(perItem) {
  if (!Array.isArray(perItem)) return [];
  return perItem.filter((f) => f && f.severity !== 'info');
}
